export const ATECO_ATTIVITA_FINANZIARIE_ASSICURATIVE = [
  '64110',
  '641100',
  '64191',
  '641910',
  '64192',
  '641920',
  '64193',
  '641930',
  '64194',
  '641940',
  '64200',
  '642000',
  '64301',
  '643010',
  '64302',
  '643020',
  '64910',
  '649100',
  '64920',
  '649201',
  '649209',
  '64991',
  '649910',
  '64992',
  '649920',
  '64993',
  '649930',
  '64994',
  '649940',
  '64995',
  '649950',
  '64996',
  '649960',
  '65110',
  '651100',
  '65120',
  '651200',
  '65200',
  '652000',
  '65301',
  '653010',
  '65302',
  '653020',
  '65303',
  '653030',
  '66110',
  '661100',
  '66210',
  '662100',
  '66220',
  '662201',
  '662202',
  '662203',
  '662204',
  '66290',
  '662901',
  '662909',
  '66300',
  '663000',
];
